module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("PART 2")]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_vm._v("The Character of Technology")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226066295_13_Part2"
    }
  }, [_vm._v("Part 2")]), _vm._v(" of this study deals with the character of technology. I have said all along that our conflicting and confusing experiences of technology can be clarified if we are able to recognize an underlying pattern in technology. And such a recognition should in turn help us to act constructively on our deeper aspirations. The constructive task is to be taken up in "), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226066295_26_Part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3")]), _vm._v(". In this part we must work out the technological pattern or paradigm. I begin with an introductory chapter which brings the character of our time into broad relief by viewing technology from the standpoint of the beginning of the modern era where the promise of technology was first formulated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is followed by a group of four chapters ("), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226066295_15_Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chaps. 9–12")]), _vm._v(") whose purpose is to describe and articulate the paradigm of technology. The stages of this enterprise are the following. I begin by considering clear instances of the technological pattern, namely, technological devices; I point up the distinctive features of such devices and highlight them against a pretechnological background. What distinguishes a device is its sharp internal division into a machinery and a commodity procured by that machinery. Next, to give a first indication of the power of the technological paradigm, I turn to one of its global manifestations, namely, the assembly of commodities that constitutes the world of consumption and the prominent foreground of technology. I then articulate the systematic standing of the technological pattern or the device paradigm, first by comparing the latter with competing modes of analysis and then by examining the status of paradigmatic explanation explicitly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Given a reasonably firm and clear understanding of the decisive pattern of technology, we can raise the question of how we have come to terms with technology socially and politically. This is the task of "), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226066295_19_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 13–16")]), _vm._v(". Again I begin with an introductory chapter in which I consider the problem of orientation in a general way and then discuss two well-known but misdirected attempts at orienting ourselves in regard to technology; the first of these is “raising the value question,” and the second the Marxist analysis of Western democracy. I then turn to the political and social understanding that today is dominant in this country, namely, to the liberal democratic view of society "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("and politics. My concern here is to show that the technological culture is the largely unspoken but pivotal issue of liberal democracy. Without modern technology, the liberal program of freedom, equality, and self-realization is unrealizable. But with a technological specification of liberal democracy, the ideal of the liberally just society, where the question of the good life is to remain open, has been surrendered to the establishment of a society that is good in a definite and dubious sense. In "), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226066295_20_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")]), _vm._v(" I try to advance this claim through a discussion of some of the eminent renditions of the liberal democratic view. I then try to show that the tensions and contradictions of liberal theory can be resolved if we envision the device paradigm explicitly. And in "), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226066295_21_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")]), _vm._v(" I suggest that such a vision is in accord with the concrete circumstances of life and with what empirical data there are on this issue. In "), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226066295_22_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")]), _vm._v(", the last of these four, I give a summary description of technological politics in which I propose that politics today has become the metadevice of the technological society; and I attempt to show that this view accounts well for two problems that trouble liberal theorists deeply, political apathy and social injustice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The two groups of chapters that outline the pattern of technology ("), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226066295_15_Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chaps. 9–12")]), _vm._v(") and examine its social and political setting ("), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226066295_19_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chaps. 13–16")]), _vm._v(") provide a fairly balanced and comprehensive view of the character of technology, but a view that lacks depth as well. This I try to remedy through a discussion of labor ("), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226066295_23_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chap. 17")]), _vm._v(") and of leisure ("), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226066295_24_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chap. 18")]), _vm._v("). My reasons for this move are two. First, it seems to me that technology is most consequential in the inconspicuous dailiness of life. And second, the labor-leisure distinction has a privileged tie to the character of technology; it represents the split of the technological device into machinery and commodity writ large. The transition to the reform of technology in "), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226066295_26_Part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3")]), _vm._v(" is conveniently made by investigating the stability of the rule of technology. Such an examination draws the previous findings together and begins to ask what openings for a reform we can count on.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10c81ef4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/9780226066295_13_Part2.vue
// module id = 93
// module chunks = 0